<template>
  <transition name="fade">
    <div v-if="modal.show" class="modal row align-center justify-center">
      {{ scrollTop() }}
      <div class="modal-box">
        <div v-if="!modal.hideClose" class="close grid-12 justify-end" @click="close()">
          <i class="fa fa-times"></i>
        </div>

        <div class="modal-box-container column">
          <div class="title grid-11" v-if="modal.title" v-html="modal.title"></div>
          <div class="description" v-if="modal.description" v-html="modal.description"></div>
          <component v-if="modal.layout" :is="modal.layout" :modal="modal"></component>
          <div v-else-if="modal.content" class="content" v-html="modal.content"></div>
          <div v-else class="content">
            <slot></slot>
          </div>
        </div>
      </div>
      <div class="background" @click="modal.show = false"></div>
    </div>
  </transition>
</template>

<script>
import Community from "@/components/modal/Community.vue";
import Academy from "@/components/modal/Academy.vue";
import Support from "@/components/modal/Support.vue";
import Orientation from "@/components/modal/Orientation.vue";
import OrientationDefault from "@/components/modal/OrientationDefault.vue";
import Note from "@/components/modal/Note.vue";
import Deslocation from "@/components/modal/Deslocation.vue";
import Checkin from "@/components/modal/Checkin.vue";
import Attach from "@/components/modal/Attach.vue";
import Finish from "@/components/modal/Finish.vue";
import Attendance from "@/components/modal/Attendance.vue";
import Competence from "@/components/modal/Competence.vue";
import Telegram from "@/components/modal/Telegram.vue";
import Comm from "@/components/modal/Comm.vue";
import Files from "@/components/modal/Files.vue";
import FirstTime from "@/components/modal/remote/FirstTime.vue";
import Guide from "@/components/modal/remote/Guide.vue";
import JobRemote from "@/components/modal/remote/Job.vue";
import AttendanceButton from "@/components/modal/AttendanceButton.vue";
import MySupporters from "@/components/modal/MySupporters.vue";
import CompCertTool from "@/components/modal/CompCertTool.vue";
import Historic from "@/components/modal/Historic.vue";
import Termo from "@/components/modal/Termo.vue";
/* import Contrato from "@/components/modal/Contrato.vue"; */
import ContratoDigital from "@/components/modal/ContratoDigital.vue";
import ContratoAdmin from "@/components/modal/ContratoAdmin.vue";
import App from "@/components/modal/App.vue";
import Regras from "@/components/modal/Regras.vue";
import Slack from "@/components/modal/Slack.vue";
import Clicksign from "@/components/modal/Clicksign.vue";
import ChavePix from "@/components/modal/ChavePix.vue";
import AddValues from "@/components/modal/AddValues.vue";
import JobCancel from "@/components/modal/JobCancel.vue";
import Reagendar from "@/components/modal/Reagendar.vue";
import Km from "@/components/modal/Km.vue";
import NF from "@/components/modal/NF.vue";
import Material from "@/components/modal/Material.vue";

export default {
  name: "Modal",
  components: {
    App,
    Files,
    Regras,
    Historic,
    Termo,
    Community,
    Academy,
    Support,
    Orientation,
    OrientationDefault,
    Note,
    Deslocation,
    Checkin,
    Attach,
    Finish,
    Attendance,
    Competence,
    Telegram,
    Comm,
    FirstTime,
    Guide,
    JobRemote,
    AttendanceButton,
    MySupporters,
    CompCertTool,
    Slack,
    Clicksign,
    ContratoAdmin,
    ChavePix,
    AddValues,
    JobCancel,
    Reagendar,
    Km,
    ContratoDigital,
    NF,
    Material
  },
  props: {
    modal: Object,
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.modal.show = false;
      if (this.modal.callback) this.modal.callback();
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/main.scss";
@use "@/assets/scss/vars.scss" as *;

.modal {

  top: 72px;
  position: absolute;
  width: 100%;
  left: 2%;
  @media (min-width: $large) {
    max-width: 96%;
  }

  .background {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 250vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 803;
  }

  &-box {
    z-index: 990;
    top: 7%;
    padding-bottom: 200px;

    @media (max-width: $large) {
      width: 90%;
      padding: 4%;
      left: 0px;
      top: 0px;
      height: 0px;
      position: absolute;
      height: 100%;
    }

    &-container {
      background: $white;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
        0 3px 1px -2px rgba(0, 0, 0, 0.12);
      border-radius: 21px;

      @media (max-width: $small) {
        position: absolute;
        left: 0px;
        width: 98%;
      }
    }

    .close {
      text-align: right;
      color: $white;
      cursor: pointer;
      font-size: 35px;

      &:hover {
        color: $red-1;
      }
    }

    .title {
      padding: 0px 30px;
      padding-top: 35px;
      font-size: 24px;
      font-weight: bold;
      color: $black;

      @media (max-width: $small) {
        font-size: 1.2rem;
      }

      strong {
        color: $green-7;
      }
    }

    .description {
      color: $gray-1;
      font-size: 18px;
      padding: 0px 30px;

      @media (max-width: $small) {
        font-size: 0.8rem;
        margin-top: 10px;
      }
    }

    .content {
      margin-top: 20px;
    }
  }
}
</style>
